/** @param {unknown} value */
export function coerceNonNegativeInt(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed < 0) {
    return 0;
  }
  return Math.floor(parsed);
}

/** @param {unknown} monthKey */
export function formatUtcMonthLabel(monthKey) {
  if (!monthKey || typeof monthKey !== 'string') {
    return '';
  }
  const parts = monthKey.split('-');
  if (parts.length !== 2) {
    return '';
  }
  const year = Number.parseInt(parts[0], 10);
  const monthNum = Number.parseInt(parts[1], 10);
  if (!Number.isFinite(year) || !Number.isFinite(monthNum) || monthNum < 1 || monthNum > 12) {
    return '';
  }
  const monthDate = new Date(Date.UTC(year, monthNum - 1, 1));
  return monthDate.toLocaleString(undefined, {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

/**
 * @typedef {Object} SplatAwardMonthlyDocLike
 * @property {string} [id]
 * @property {string} [date] YYYY-MM
 * @property {Object} [metrics]
 */

/**
 * @param {readonly SplatAwardMonthlyDocLike[]} documents newest-first from Firestore
 * @returns {Array<{ id: string, monthKey: string, monthLabel: string, totalSplatsEarned: number }>}
 */
/**
 * Oldest-first order for time-series charts (hook returns newest-first).
 * @param {Array<{ monthKey: string, monthLabel: string, totalSplatsEarned: number, id: string }>} rows
 */
export function orderSplatAwardMonthlyChartRows(rows) {
  return [...rows].reverse();
}

export function buildSplatAwardMonthlyTableRows(documents) {
  return documents.map((documentRow, rowIndex) => {
    const monthKey = typeof documentRow.date === 'string' ? documentRow.date : '';
    const metrics =
      typeof documentRow.metrics === 'object' && documentRow.metrics !== null
        ? documentRow.metrics
        : {};
    const fallbackId = monthKey ? `monthly_${monthKey}` : `monthly_unknown_${rowIndex}`;
    return {
      id: documentRow.id ?? fallbackId,
      monthKey,
      monthLabel: formatUtcMonthLabel(monthKey),
      totalSplatsEarned: coerceNonNegativeInt(metrics.totalSplatsEarned),
    };
  });
}
